import React, { Component } from 'react'
import './MyGallery.scss'

import { MyUploadedVideo } from './MyUploadedVideo'
import ProfileChageDialog from './ProfileChageDialog'
import MyLikedVideo from './MyLikedVideo'
import Uploading from '@/Common/Uploading/Uploading'
import ShareDialog from '../MyVideo/ShareDialog/ShareDialog';
import OneBtnDialog from "../../Common/OneBtnDialog/OneBtnDialog";

import CopyToClipboard from 'copy-to-clipboard'
import i18n from '../../i18n'
import axios from "axios";
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { connect } from 'react-redux'
import FollowerListDialog from '../../Gallery/FollowerListDialog'

import FormatHelper from '../../utils/FormatHelper'

import './MyGallery.scss'

import { SetUserProfileURL, ResetUserProfile, FetchPoint } from '../../Interface'
import { getIsExpiredDate } from '@/utils/DateHelper'
import { POINT_UI_EXPIRED_DATE } from '@/utils/Global'

class MyGallery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isHeaderActivated: [true, false, false],
            usersAggregateData: {},
            isProfileDialogOpen: false,
            isUploadingProfile: false,
            isOpenedFollowListDialog: false,
            isOpenShareUserGalleryDialog: false,
            isBtnDialogOpened: false,
            dialogType: "shareSuccess",

            itemPerPage: 32,

            curFollowingPage: 0,
            followingItemCount: 0,
            followingList: [],

            curFollowerPage: 0,
            followerItemCount: 0,
            followerList: []
        }
    }

    componentDidMount() {
        FetchPoint()
        this.getUsersAggregate()
    }

    getUsersAggregate = async () => {
        const { currentUser } = this.props
        if(!currentUser || !currentUser.shareId) return;

        const response = await axios.get(`${GetBaseUrl()}/apis/users/${currentUser.shareId}/gallerys/aggregate`)

        this.setState({ usersAggregateData: response.data.data })
    }

    handleClickHeader = index => e => {
        let tmpArr = [false, false, false]
        tmpArr[index] = true
        this.setState({ isHeaderActivated: tmpArr })
    }

    handleUploadImage = () => this.setState({ isProfileDialogOpen: true })

    uploadImage = async file => {
        const { currentUser } = this.props
        this.setState({ isProfileDialogOpen: false })
        await SetUserProfileURL(file, currentUser._id, bool => this.setIsUploadingProfile(bool))
    }

    resetProfile = async () => {
        await ResetUserProfile()
        this.setState({ isProfileDialogOpen: false })
    }

    handleCloseDialog = () => this.setState({ isProfileDialogOpen: false })

    setIsUploadingProfile = bool => this.setState({ isUploadingProfile: bool })

    renderMenu = () => {
        const { isHeaderActivated } = this.state
        const menuArr = ['web.mygallery.my-video', 'web.mygallery.liked', 'web.mygallery.commented']
        return (
            <div className='data-sorting-header'>
                {menuArr.map((elem, index) => (
                    <div 
                        className={`sorting-header ${isHeaderActivated[index] ? 'focused' : '' }`}
                        onClick={this.handleClickHeader(index)}
                    >
                        {i18n.t(elem)}
                    </div>
                ))}
            </div>
        )
    }

    renderBody = () => {
        const { isHeaderActivated } = this.state

        return (
            <>
                {/* 갤러리 공유 동영상 */}
                {
                    isHeaderActivated[0] &&
                    <MyUploadedVideo
                    {...this.props}
                    isMounted={this.props.isMounted}
                    paymentMode={this.props.paymentMode}
                    currentUser={this.props.currentUser}
                    refreshUserData={this.props.refreshUserData}
                    isDownloadable={this.props.accountStatus.isDownloadable}
                    value={this.props.value}
                    getUsersAggregate={this.getUsersAggregate}
                  /> 
                }

                {/* 좋아한 동영상 or 댓글단 동영상 */}
                {
                    (isHeaderActivated[1] || isHeaderActivated[2]) &&
                    <MyLikedVideo
                        {...this.props}
                        endpoint={isHeaderActivated[1] ? 'liked' : 'commented'}
                    />
                }
            </>
        )
    }

    handleClickFollowListDialogCloseBtn = () => {
        this.setState({ 
            isOpenedFollowListDialog: false, 
            curFollowerPage: 0, 
            followerList: [], 
            followerItemCount: undefined, 
            curFollowingPage: 0, 
            followingList: [],
            followingItemCount: undefined
        })
        this.getUsersAggregate()
    }

    handleClickFollowListDialogFollowBtn = async (followInfo, targetType) => {
        const { followingList, followerList } = this.state

        const shareId = followInfo.shareId
        const token = localStorage.getItem("token")
        
        try {
            const newFollowingList = followingList.map(e => e)
            const newFollowerList = followerList.map(e => e)
            if(followInfo.isFollowed) {
                const res = await axios.delete(`${GetBaseUrl()}/apis/follow/${shareId}`, { headers: { Authorization: `Bearer ${token}` } })

                if(res.data.message === 'success') {
                    newFollowingList.forEach(e => { if(e.shareId === followInfo.shareId ) e.isFollowed = false })
                    newFollowerList.forEach(e => { if(e.shareId === followInfo.shareId ) e.isFollowed = false })
                }
            }
            else {
                const res = await axios.post(`${GetBaseUrl()}/apis/follow`, { userid: shareId }, { headers: { Authorization: `Bearer ${token}` } })

                if(res.data.message === 'success') {
                    newFollowingList.forEach(e => { if(e.shareId === followInfo.shareId ) e.isFollowed = true })
                    newFollowerList.forEach(e => { if(e.shareId === followInfo.shareId ) e.isFollowed = true })
                }
            }         
            
            this.getUsersAggregate()
            this.setState({ followingList: newFollowingList, followerList: newFollowerList })
        }
        catch(e) {
            console.log(e)
        }
    }

    getFollowers = async (isInit = false) => {
        const { followerList } = this.state
        const newFollowingList = isInit ? [] : followerList.map(e => e)

        const token = localStorage.getItem('token')
        const shareId = this.props.currentUser.shareId
        const config = { headers: { Authorization: `Bearer ${token}` } }

        const pageIndex = isInit ? 0 : this.state.curFollowerPage
        const pageItemCount = this.state.itemPerPage
        
        try {
            // 나를 팔로우한 사람
            const res = await axios.get(`${GetBaseUrl()}/apis/follow/${shareId}/follower?offset=${pageIndex}&limit=${pageItemCount}`, config)
            const { list, count } = res.data.data

            if(list && list.length > 0) newFollowingList.push(...list)
            
            this.setState({ 
                followerList: newFollowingList,
                followerItemCount: count,
                curFollowerPage: pageIndex + 1
             })
        }
        catch(e) {
            console.log(e)
        }
    }

    getFollowings = async (isInit = false) => {
        const { followingList } = this.state
        const newFollowingList = isInit ? [] : followingList.map(e => e)

        const token = localStorage.getItem('token')
        const shareId = this.props.currentUser.shareId
        const config = { headers: { Authorization: `Bearer ${token}` } }

        const pageIndex = isInit ? 0 : this.state.curFollowingPage
        const pageItemCount = this.state.itemPerPage

        try {
            // 내가 팔로우한 사람
            const res = await axios.get(`${GetBaseUrl()}/apis/follow/${shareId}/followed?offset=${pageIndex}&limit=${pageItemCount}`, config)
            const { list, count } = res.data.data
            
            if(list && list.length > 0) newFollowingList.push(...list)

            this.setState({ 
                followingList: newFollowingList,
                followingItemCount: count,
                curFollowingPage: pageIndex + 1
             })
        }
        catch(e) {
            console.log(e)
        }
    }

    handleClickShareUserGalleryBtn = () => {
        // 공유 다이얼로그
        this.setState({ isOpenShareUserGalleryDialog: true })
    }

    handleClickCloseShareUserGalleryDialog = () => {
        this.setState({ isOpenShareUserGalleryDialog: false })
    }

    handleClickShareUserGallery = async method => {
        const { currentUser } = this.props
        try {
            const userShareId = currentUser.shareId
            const shareLink = window.location.origin + `/user-gallery/${userShareId}`
            const { invokeCSharpAction } = window
            const isXamarin = invokeCSharpAction
            switch (method) {
                case 'twitter':
                case 'facebook':
                    let targetLink = 'about:blank'
                    if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
                    else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

                    if (isXamarin) window.location.href = targetLink
                    else {
                        const windowRef = window.open(targetLink, '_blank')
                        if (!windowRef) this.setState({
                            isBtnDialogOpened: true,
                            dialogType: "shareLinkBlock"
                        })
                    }
                    break
                case 'linkxamarin':
                    window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
                    break

                case 'link':
                default:
                    CopyToClipboard(shareLink)
                    this.setState({
                        isBtnDialogOpened: true,
                        dialogType: "shareSuccess"
                    })
                    break
            }
        }
        catch (e) {
            this.setState({
                isBtnDialogOpened: true,
                dialogType: "shareFail"
            })
        }
    }

    handleClickFollowInfo = async () => {
        const { curFollowerPage, curFollowingPage } = this.state
        
        if(curFollowerPage === 0 && curFollowingPage === 0) {
            await Promise.all([this.getFollowers(), this.getFollowings()])
        }

        this.setState({ isOpenedFollowListDialog: true })
    }

    handleClickFollowListDialogProfile = (followInfo) => {     
        const shareId = followInfo.shareId
        const userId = followInfo.userId
        const nxtPath = `/user-gallery/${shareId}/${userId}`
        
        if (!shareId || !userId || nxtPath === window.location.pathname) return
        this.props.history.push(nxtPath)
    }

    handleClickPointShopBtn = () => {
        this.props.history.push('my-point')
    }

    popupHandleCloseBtn = () => this.setState({ isBtnDialogOpened: false })

    renderHeading = () => {
        const { usersAggregateData: { viewsCount, videoCount, likesCount, commentsCount } } = this.state

        return (
            <>
                <div className="my-gallery-title-detail-pannel">
                    <img src="https://front.videomonster.com/images-7cuytg20/web/icon-view.svg" alt="icon-video" />
                    <span className="my-gallery-title-detail-span">{FormatHelper.convertToKMB(viewsCount || 0)}</span>
                    <span className="my-gallery-title-detail-divide">|</span>

                    <img src="https://front.videomonster.com/images-7cuytg20/web/icon-video.svg" alt="icon-video" />
                    <span className="my-gallery-title-detail-span">{FormatHelper.convertToKMB(videoCount || 0)}</span>
                    <span className="my-gallery-title-detail-divide">|</span>

                    <img src="https://front.videomonster.com/images-7cuytg20/web/icon-like.svg" alt="icon-like" />
                    <span className="my-gallery-title-detail-span">{FormatHelper.convertToKMB(likesCount || 0)}</span>
                    <span className="my-gallery-title-detail-divide">|</span>

                    <img src="https://front.videomonster.com/images-7cuytg20/web/icon-comment.svg" alt="icon-comment" />
                    <span className="my-gallery-title-detail-span">{FormatHelper.convertToKMB(commentsCount || 0)}</span>
                </div>
            </>
        )
    }

    render() {
        const { 
            currentUser, 
            myProfileURL,
            point
        } = this.props
        const { 
            isProfileDialogOpen, 
            isOpenedFollowListDialog, 
            isOpenShareUserGalleryDialog,
            isBtnDialogOpened,
            dialogType,
            followingList, 
            followerList,
            usersAggregateData: { followerCount, followedCount }
        } = this.state
        
        return (
            <div className='my-gallery-root'>
                <div className="my-gallery-container">
                    <div className='my-gallery-title'>
                        <div className='my-gallery-title-profile'>
                            {myProfileURL && <img src={myProfileURL === 'baseImg' ? "https://front.videomonster.com/images-7cuytg20/common/v2-profile.svg" : myProfileURL} alt='profile' onClick={this.handleUploadImage} />}
                            <div className='my-gallery-profile-change' onClick={this.handleUploadImage}>
                                <img src="https://front.videomonster.com/images-7cuytg20/web/change_profile_icon.svg" alt="icon-change-profile" />
                            </div>
                        </div>
                        <div className='my-gallery-title-right-pannel'>

                            {/* 유저 이름 & 공유 버튼 */}
                            <div className="my-gallery-detail">
                                <div className="my-gallery-profile-name">
                                    {currentUser && currentUser.displayName}
                                </div>

                                <img
                                    src="https://front.videomonster.com/images-7cuytg20/web/shareIcon_box_new.svg"
                                    alt="icon-share"
                                    onClick={this.handleClickShareUserGalleryBtn}
                                />
                            </div>

                            {/* 팔로우 000 & 팔로워 000 */}
                            <div className="my-gallery-title-follow-container" onClick={() => { this.handleClickFollowInfo() }}>
                                <div className={"my-gallery-title-follow-item"}>
                                    <div>{i18n.t("global.follower")}</div>
                                    <div>{followerCount || 0}</div>
                                </div>

                                <div className={"my-gallery-title-follow-item"}>
                                    <div>{i18n.t("global.follow")}</div>
                                    <div>{followedCount || 0}</div>
                                </div>
                            </div>

                            {
                                getIsExpiredDate(POINT_UI_EXPIRED_DATE) &&
                                <div className="my-gallery-title-point-container">
                                    <div className="my-gallery-title-point-icon">P</div>
                                    <div className="my-gallery-title-point-value">{point} Point</div>
                                    <div className="my-gallery-title-point-shop-btn" onClick={this.handleClickPointShopBtn}>
                                        <img src="https://front.videomonster.com/images-7cuytg20/web/pointShopIcon.svg" alt="icon-point-shop" />
                                        Point Shop
                                    </div>
                                </div>
                            }

                            {this.renderHeading()}
                        </div>
                    </div>
                    <div className='my-gallery-body'>
                        {this.renderMenu()}
                        {this.renderBody()}
                    </div>
                </div>
                <ProfileChageDialog
                    open={isProfileDialogOpen}
                    onClose={this.handleCloseDialog}
                    onChangeProfile={this.uploadImage}
                    onResetProfile={this.resetProfile}
                />
                <FollowerListDialog 
                    open={isOpenedFollowListDialog}
                    followingList={followingList}
                    followerList={followerList}
                    followingCount={followedCount || 0}
                    followerCount={followerCount || 0}
                    onClickCloseDialog={this.handleClickFollowListDialogCloseBtn}
                    onClickFollowBtn={this.handleClickFollowListDialogFollowBtn}
                    onClickUserProfile={this.handleClickFollowListDialogProfile}
                    getFollowers={this.getFollowers}
                    getFollowings={this.getFollowings}
                />
                <ShareDialog
                    open={isOpenShareUserGalleryDialog}
                    onClose={this.handleClickCloseShareUserGalleryDialog}
                    onShare={this.handleClickShareUserGallery}
                />
                <OneBtnDialog
                    dialogType={dialogType}
                    open={isBtnDialogOpened}
                    closeBtn={this.popupHandleCloseBtn}
                    onButtonClick={this.popupHandleCloseBtn}
                />
                <Uploading open={this.state.isUploadingProfile} progress={0} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    paymentMode: state.paymentModeStore.paymentMode,
    point: state.pointStore.point,
    accountStatus: state.accountStatusStore.accountStatus,
    myProfileURL: state.myProfileURLStore.myProfileURL
})

export default connect(mapStateToProps, null)(MyGallery)